'use client'

import { memo, useState } from 'react'

import { StoreBonusStatusResponse } from '@common/models/bonus'

import { useGetDraftQuery } from '@/api'
import { useGameSlug } from '@/features/storefronts/game-provider'

import { BonusFooter } from '../bonusFooter/bonusFooter'
import { DrawerButton } from '../bonusFooter/DrawerButton'
import { BonusesAndPoints } from './BonusesAndPoints'
import { getNextItem } from './bonusUtils'

import styles from './bonusContainer.module.scss'

interface BonusContainerProps {
  bonusStatus: StoreBonusStatusResponse
}

const HIDE_BONUS_IF_NO_DATA = false

export const BonusContainer = memo(({ bonusStatus }: BonusContainerProps) => {
  const gameSlug = useGameSlug()
  const { data: draft } = useGetDraftQuery(gameSlug)
  const [isOpen, setIsOpen] = useState(false)

  if (HIDE_BONUS_IF_NO_DATA && !bonusStatus) {
    return null
  }

  const nextItem = getNextItem({ bonusStatus, draft })

  if (HIDE_BONUS_IF_NO_DATA && !nextItem) {
    return null
  }

  const openDrawer = (e: React.MouseEvent<HTMLDivElement>) => {
    e.preventDefault()
    setIsOpen((wasOpen) => {
      document.body.style.overflow = wasOpen ? 'auto' : 'hidden'
      return !wasOpen
    })
  }

  return (
    <aside className={`${styles.stickyContainer} ${isOpen && styles.open}`}>
      <div className={styles.contentContainer}>
        {!isOpen && <BonusFooter bonusStatus={bonusStatus} isDrawerOpen={isOpen} onOpenDrawer={openDrawer} />}
        {isOpen && (
          <>
            <div className={styles.drawerButtonContainer}>
              <DrawerButton isOpen={isOpen} onClick={openDrawer} />
            </div>
            <BonusesAndPoints bonusStatus={bonusStatus} />
          </>
        )}
      </div>
    </aside>
  )
})

BonusContainer.displayName = 'BonusContainer'
